/*
 * minimal-genero.js — Botón "+" de las tarjetas en las secciones minimal-genero-productos.
 * /cart/add.js + refresca burbuja y cart-drawer del tema y lo abre (mismo patrón que
 * minimal-coleccion.js). Delegado en document, una sola vez aunque haya varias secciones.
 */
(function () {
  'use strict';
  if (typeof document === 'undefined' || window.__mgInit) return;
  window.__mgInit = true;

  function refreshBubble(sections) {
    try {
      if (sections && sections['cart-icon-bubble']) {
        var p = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var t = document.getElementById('cart-icon-bubble');
        var s = p.querySelector('#shopify-section-cart-icon-bubble') || p.querySelector('.shopify-section');
        if (t && s) t.innerHTML = s.innerHTML;
      }
    } catch (e) {}
  }
  function updateDrawer(sections) {
    try {
      if (sections && sections['cart-drawer']) {
        var p = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var t = document.querySelector('cart-drawer');
        var s = p.querySelector('cart-drawer');
        if (t && s) {
          t.classList.toggle('is-empty', s.classList.contains('is-empty'));
          t.innerHTML = s.innerHTML;
        }
      }
    } catch (e) {}
  }
  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-mg-root] [data-mc-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: id, quantity: 1,
        sections: 'cart-icon-bubble,cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        refreshBubble(data.sections);
        updateDrawer(data.sections);
        if (!openDrawer()) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  /* ============ Carrusel de imágenes en tarjetas ============
     Mobile: deslizar (scroll-snap) + puntos. Escritorio: flechas al pasar el mouse.
     URLs desde el JSON [data-mg-swipe] de cada sección. Clases .mgs-* propias
     (minimal-coleccion-swipe.css oculta su carrusel en escritorio). */
  var WIDTHS = [360, 540, 720];

  function sized(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function arrow(dir) {
    var a = document.createElement('span');
    a.className = 'mgs-arrow mgs-arrow--' + dir;
    a.setAttribute('data-mgs-arrow', dir);
    a.setAttribute('aria-hidden', 'true');
    a.innerHTML = dir === 'prev'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M15 5l-7 7 7 7"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M9 5l7 7-7 7"/></svg>';
    return a;
  }

  function build(card, urls) {
    var media = card.querySelector('.mc-card__media');
    if (!media || urls.length < 2 || media.querySelector('.mgs-track')) return;

    var main = media.querySelector('.mc-card__img--main');
    var ratio = 1;
    if (main && main.getAttribute('width') && main.getAttribute('height')) {
      ratio = parseInt(main.getAttribute('width'), 10) / parseInt(main.getAttribute('height'), 10) || 1;
    }
    var alt = main ? main.getAttribute('alt') || '' : '';

    var track = document.createElement('div');
    track.className = 'mgs-track';
    track.style.setProperty('--mgs-ratio', ratio);

    urls.forEach(function (url, i) {
      var slide = document.createElement('div');
      slide.className = 'mgs-slide';
      var img = document.createElement('img');
      if (i === 0 && main) {
        img.src = main.currentSrc || main.src;
        if (main.srcset) img.srcset = main.srcset;
        img.loading = 'eager';
      } else {
        img.src = sized(url, 540);
        img.srcset = WIDTHS.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ');
        img.loading = 'lazy';
      }
      img.sizes = '(min-width:768px) 25vw, 50vw';
      img.alt = i === 0 ? alt : '';
      if (i > 0) img.setAttribute('aria-hidden', 'true');
      img.draggable = false;
      slide.appendChild(img);
      track.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'mgs-dots';
    dots.setAttribute('aria-hidden', 'true');
    urls.forEach(function (_, i) {
      var d = document.createElement('span');
      d.className = 'mgs-dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
        var list = dots.children;
        for (var k = 0; k < list.length; k++) list[k].classList.toggle('is-active', k === idx);
      });
    }, { passive: true });

    media.appendChild(track);
    media.appendChild(dots);
    media.appendChild(arrow('prev'));
    media.appendChild(arrow('next'));
    media.classList.add('mgs-on');
  }

  // Flechas: viven dentro del <a> de la tarjeta, así que se corta la navegación.
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-mgs-arrow]') : null;
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    var track = a.parentNode.querySelector('.mgs-track');
    if (!track) return;
    var w = track.clientWidth || 1;
    var n = track.children.length;
    var idx = Math.round(track.scrollLeft / w);
    var next = a.getAttribute('data-mgs-arrow') === 'next' ? idx + 1 : idx - 1;
    if (next >= n) next = 0;
    if (next < 0) next = n - 1;
    track.scrollTo({ left: next * w, behavior: 'smooth' });
  });

  function initSwipe() {
    document.querySelectorAll('[data-mg-root]').forEach(function (root) {
      var el = root.querySelector('[data-mg-swipe]');
      if (!el) return;
      var map = {};
      try { map = JSON.parse(el.textContent) || {}; } catch (e) { return; }
      root.querySelectorAll('[data-mc-card]').forEach(function (card) {
        if (card.hasAttribute('data-mgs')) return;
        card.setAttribute('data-mgs', '');
        build(card, map[card.getAttribute('data-product-id')] || []);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSwipe);
  else initSwipe();
  // Editor de temas: al cambiar las fragancias la sección se re-renderiza.
  document.addEventListener('shopify:section:load', initSwipe);
})();
